"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  queryClient: true,
  QueryProvider: true
};
exports.queryClient = exports.default = exports.QueryProvider = void 0;
var _querySyncStoragePersister = require("@tanstack/query-sync-storage-persister");
var _reactQuery = require("@tanstack/react-query");
Object.keys(_reactQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _reactQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _reactQuery[key];
    }
  });
});
var _reactQueryPersistClient = require("@tanstack/react-query-persist-client");
var _Cookie = _interopRequireDefault(require("../packages/Cookie"));
var _jsxRuntime = require("react/jsx-runtime");
const [id_token] = (0, _Cookie.default)("id_token");
const cacheTime = 1000 * 60 * 60 * 1; // 1 Hour

const queryClient = exports.queryClient = new _reactQuery.QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
      cacheTime
    }
  }
});
try {
  var _window, _window$location, _window2, _window2$location;
  const persister = (0, _querySyncStoragePersister.createSyncStoragePersister)({
    storage: window.sessionStorage
  });
  if (!((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.search) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.search.indexOf("disableCache=true")) === -1) {
    (0, _reactQueryPersistClient.persistQueryClient)({
      queryClient,
      persister,
      maxAge: cacheTime,
      buster: id_token,
      dehydrateOptions: {
        shouldDehydrateQuery: function (query) {
          var _query$options, _query$options$meta;
          return (0, _reactQuery.defaultShouldDehydrateQuery)(query) && (query === null || query === void 0 ? void 0 : (_query$options = query.options) === null || _query$options === void 0 ? void 0 : (_query$options$meta = _query$options.meta) === null || _query$options$meta === void 0 ? void 0 : _query$options$meta.disableCache) !== true;
        }
      }
    });
  }
} catch (e) {}
const QueryProvider = function (_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactQuery.QueryClientProvider, {
    client: queryClient,
    "data-testid": "QueryProvider",
    children: children
  });
};
exports.QueryProvider = QueryProvider;
var _default = exports.default = queryClient;